import React, { createContext, useContext, useState } from "react";

// Create the context
const LoaderContext = createContext();

// Create a provider component
export const LoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const handleLoader = (value) => {
    setLoader(value);
  };

  return (
    <LoaderContext.Provider value={{ loader, handleLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
